export default __webpack_public_path__ + "static/media/metasul.2bc61ce2.png";